import { getUserDetails } from '@/api/order';

export function getShopName(hostId, zoneId) {
  if (hostId == 1 && !zoneId) {
    return '数智化商城';
  }
  if (hostId == 1 && zoneId == 3) {
    return '积分商城';
  }
  return '中小企业商城';
}

//
export function hinaGetOrderInfo(orderId) {
  return new Promise((resolve, reject) => {
    getUserDetails(orderId, {}).then(res => {
      resolve(res);
    });
  });
}
// 处理attr
export function hinaHandleAttr(attr) {
  let attrstr = '';
  try {
    const sku = JSON.parse(attr);
    console.log('sku: ', sku);
    attrstr = sku.map(item => `${item.key}：${item.value}`).join('；');
  } catch {
    attrstr = '';
  }
  return attrstr;
}
